var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdvantages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 147,
    height: 142,
    viewBox: "0 0 147 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M132.002 38.6363C132.002 50.7239 116.152 56.5435 104.002 56.5435C91.8517 56.5435 88.002 50.7239 88.002 38.6363C88.002 26.5488 103.352 16.2524 115.502 16.2524C127.652 16.2524 132.002 26.5488 132.002 38.6363Z",
    fill: "#43D48A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4331 43.2012C41.6842 22.5343 56.4944 4.32213 80.4479 18.0804C93.045 25.3157 117.182 46.8814 123.572 68.3293C133.368 85.4212 119.003 103.377 112.615 114.385C99.14 137.604 70.8022 125.969 46.8486 112.211C22.8951 98.4524 10.9582 66.4199 24.4331 43.2012Z",
    fill: "#F5F5F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2209 94.7524C64.5542 96.4191 72.9209 99.7524 79.7209 99.7524C88.2209 99.7524 94.7209 97.2524 90.2209 92.7524C92.7209 94.2524 100.221 88.7524 93.7209 85.7524C99.7209 84.2524 100.721 80.2524 94.2209 77.2524C101.721 74.7524 98.2209 68.2524 94.2209 67.7524C90.2209 67.2524 89.7209 67.2524 85.2209 66.7524C80.7209 66.2524 80.2209 64.2524 81.7209 61.7524C86.2209 54.7524 84.7209 46.7524 84.2209 44.7524C83.7209 42.7524 77.7209 39.2524 78.7209 45.7524C79.7209 52.2524 72.2209 58.7524 68.2209 65.7524C65.0209 71.3524 59.5542 72.4191 57.2209 72.2524C57.2209 71.7524 57.0209 70.7524 56.2209 70.7524C55.2209 70.7524 50.7209 70.7524 50.2209 70.7524C49.7209 70.7524 48.7209 71.7524 48.2209 73.7524C47.8209 75.3524 48.0542 88.4191 48.2209 94.7524C48.3876 95.5858 49.021 97.1524 50.2209 96.7524C51.7207 96.2524 55.2209 96.7524 56.2209 96.7524C57.2209 96.7524 58.2209 95.7524 58.2209 92.7524C58.2209 90.3524 58.2209 80.0858 58.2209 75.2524",
    stroke: "#3D3935",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M132.002 38.6363C132.002 50.7239 116.152 56.5435 104.002 56.5435C91.8517 56.5435 88.002 50.7239 88.002 38.6363C88.002 26.5488 103.352 16.2524 115.502 16.2524C127.652 16.2524 132.002 26.5488 132.002 38.6363Z",
    fill: "#EF533F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M102.055 36.6217C103.555 38.6113 106.755 42.4912 107.555 42.0933C108.555 41.5959 114.055 33.6371 117.055 31.6475",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvantages);
export default __webpack_public_path__ + "static/media/advantages.2b6891cdaf932fd760f624bcce6b1937.svg";
export { ForwardRef as ReactComponent };